import React, { useEffect, useState } from 'react';
import '../CSS/Global.css';
import Header from './Header';
import track from '../Images/track.webp';
import vegetable from '../Images/004-vegetable.png'
import fruits from '../Images/009-fruits.png'
import { useNavigate, useParams } from 'react-router-dom';
import { Button, useDisclosure } from '@chakra-ui/react';
import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    AlertDialogCloseButton,
} from '@chakra-ui/react'

const Track = () => {
    const [activeStep, setActiveStep] = useState(1); // Default active step: "dispatch"

    const steps = ["order placed", "dispatch", "out for delivery", "delivered"];

    let navigate = useNavigate();
    let [order, setOrder] = useState({});
    let [orderprod, setOrderProd] = useState([])
    let login = JSON.parse(localStorage.getItem("login")) || "";
    let { id } = useParams()
    let [totalPrice, setTotalPrice] = useState(0);
    let [totalStrikeOffPrice, setTotalStrikeOffPrice] = useState(0);
    let [addresspro, setAddressPro] = useState({})
    const { isOpen, onOpen, onClose } = useDisclosure()

    const statusToStep = {
        "Order Placed": 1,
        "Pending": 1,
        "Dispatch": 2,
        "Out for Delivery": 3,
        "Delivered": 4,
    };

    const fetchOrderData = async () => {
        try {
            const response = await fetch(`https://filmlocation.100billion.in/pay-all/order/${id}`);
            const res = await response.json();
            console.log(res.data);

            // Parse cart_product and user_address fields
            const parsedOrder = {
                ...res.data,
                product: (() => {
                    const p = res.data?.product ?? res.data?.cart_product;
                    return p ? (typeof p === 'string' ? JSON.parse(p) : p) : [];
                })(),
                user_address: (() => {
                    const u = res.data?.user_address;
                    return u ? (typeof u === 'string' ? JSON.parse(u) : u) : {};
                })(),
                vendor_address: (() => {
                    const v = res.data?.vendor_address;
                    return v ? (typeof v === 'string' ? JSON.parse(v) : v) : {};
                })(),
            };

            // Set parsed order details
            setOrder(parsedOrder);
            setOrderProd(parsedOrder.product);
            setAddressPro(parsedOrder.user_address);

            // Calculate total prices
            let totalPrice = 0;
            let totalStrikeOffPrice = 0;

            (parsedOrder.product || []).forEach((product) => {
                totalPrice += product.product.mrp_price * product.quantity;
                totalStrikeOffPrice += product.product.sell_price * product.quantity;
            });

            const step = statusToStep[parsedOrder.status] || 1; // Default to "Order Placed" if status is unknown
            setActiveStep(step);
            setTotalPrice(totalPrice);
            setTotalStrikeOffPrice(totalStrikeOffPrice);
        } catch (error) {
            console.log(error);
        }
    };



    console.log(totalPrice)
    console.log(totalStrikeOffPrice)

    let logout = () => {

        localStorage.removeItem("login");
        window.location.reload();
    }

    useEffect(() => {
        fetchOrderData();
    }, [])

    return (
        <>
            <AlertDialog
                motionPreset='slideInBottom'
                // leastDestructiveRef={cancelRef}
                onClose={onClose}
                isOpen={isOpen}
                isCentered
            >
                <AlertDialogOverlay />

                <AlertDialogContent>
                    <AlertDialogHeader>Invoice</AlertDialogHeader>
                    <AlertDialogCloseButton />
                    <AlertDialogBody>
                        Download Invoice  Coming Soon!
                        {/* Are you sure you want to discard all of your notes? 44 words will be
                        deleted. */}
                    </AlertDialogBody>
                    <AlertDialogFooter>
                        {/* <Button ref={cancelRef} onClick={onClose}>
                            No
                        </Button>
                        <Button colorScheme='red' ml={3}>
                            Yes
                        </Button> */}
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialog>
            <Header />
            <div className="track-page track-page--user">
                <div className="track-page-container">
                    <div className="track">
                        <img src={track} alt="Track your production" />
                    </div>
                    <div className="track-mapping">
                <p className="production-timeline-heading">Production timeline</p>
                <div className="track-order-number">
                    <p className="order-id">Booking / project #{order.transaction_id}</p>
                </div>
                <div className="mapping">
                    {steps.map((step, index) => (
                        <React.Fragment key={index}>
                            <div
                                className={`step 
                                    ${index + 1 < activeStep ? "active" : ""}
                                    ${index + 1 === activeStep ? "active pulse" : ""}
                                `}
                            >
                                <span className="step-rail">
                                    <span className="dot"></span>
                                </span>
                                <p className="step-label">{step}</p>
                            </div>
                            {index < steps.length - 1 && <div className="line" aria-hidden="true"></div>}
                        </React.Fragment>
                    ))}
                </div>
            </div>
            <div className="track-orders-list">
                <div className="ordered-items">Items in this production</div>
                {(orderprod || []).map((product, index) => (
                    <div className="item-list" key={index}>
                        <div className="ordered-item-img">
                            <img
                                src={`https://filmlocation.100billion.in/${product.product?.product_image || ''}`}
                                alt={product.product?.product_name || 'Product'}
                            />
                        </div>
                        <div className="ordered-item-detail">
                            <p className="product-name">{product.product?.product_name}</p>
                            <p className="actual-amount">
                                <span className="line-through">₹{(product.product?.mrp_price || 0).toFixed(2)}</span>
                                <span className="percent-discount">
                                    {product.product?.mrp_price ? Math.round(
                                        ((product.product.mrp_price - (product.product.sell_price || 0)) /
                                            product.product.mrp_price) *
                                        100
                                    ) : 0}
                                    % Off
                                </span>
                            </p>
                            <div className="discount-quantity">
                                <p className="discount-amount">₹{(product.product?.sell_price || 0).toFixed(2)}</p>
                                <p className="quantity">{product.quantity} Qty</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className="bill-details">
                <div className="bill-details-header">Bill Details</div>
                <div className="bill-saved">
                    You saved ₹{(totalPrice - totalStrikeOffPrice).toFixed(2)} on this booking / project
                </div>
                <div className="mrp-div">
                    <p className="mrp-title">MRP</p>
                    <p className="mrp">₹{totalPrice.toFixed(2)}</p>
                </div>
                <div className="discount-div">
                    <p className="discount-title">Discount</p>
                    <p className="discount">-₹{(totalPrice - totalStrikeOffPrice).toFixed(2)}</p>
                </div>
                {/* <div className="tax-div">
                    <p className="tax-title">Tax</p>
                    <p className="taxes">₹11.00</p>
                </div> */}
                <div className="delivery-div">
                    <p className="delivery-title">Delivery Charges</p>
                    <p className="delivery-charge">₹{order.delivery_amount || 0.0}</p>
                </div>
                {
                    order.payment_mode !== "PARTIAL_COD" &&
                    <div className="bill-total">
                        <p className="payable">Payable</p>
                        <p className="total-amt">
                            ₹{(totalStrikeOffPrice + (order.delivery_amount || 0.0)).toFixed(2)}
                        </p>
                    </div>
                }
                {
                    order.payment_mode === "PARTIAL_COD" && (
                        <div className="bill-total">
                            <p className="payable">Payable</p>
                            <p className="total-amt">
                                ₹{(Number(order.remaining_amount) + (order.delivery_amount || 0.0)).toFixed(2)}
                            </p>
                        </div>
                    )
                }
                {
                    order.payment_mode === "PARTIAL_COD" && (
                        <div className="bill-total">
                            <p className="payable">Advance Paid </p>
                            <p className="total-amt">
                                ₹{((totalStrikeOffPrice+ (order.delivery_amount || 0.0))-(Number(order.remaining_amount))).toFixed(2)}
                            </p>
                        </div>
                    )
                }
                <div className="payment-mode">
                    <p className="payment-mode-title">Payment Mode</p>
                    <p className="type">{order.payment_mode}</p>
                </div>

                {order.note && (
                    <div className='ordernotebox1new'>
                        <div className="order-note-box">
                            <p className="note-title">Delivery Note</p>
                            <p className="note-text">{order.note}</p>
                        </div>
                    </div>
                )}

                <div className="download-invoice">
                    {/* <button className="download" onClick={()=>navigate(`/invoice`)}>
                        Download Invoice
                    </button> */}
                </div>
            </div>
            </div>
            </div>
        </>
    );

};

export default Track;
